import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { withTranslation } from "react-i18next";
import * as R from "ramda";
import * as Yup from "yup";
import { Content } from "@worcket/common/components/layout";
import { isLoading } from "@worcket/common/hocs";

import Page from "../../../components/display/Page";
import Message from "../../../components/feedback/Message";
import { Form, FormConfig } from "../../../components/controls/FormikForm";
import DetailsForm from "../../../forms/team/Details";
import UsersForm from "../../../forms/team/Users";
import { updateTeam, UPDATE_TEAM } from "../../../store/actions/team";
import { formatTeamUsers, parseTeamUsers } from "../../../store/selectors/team";
import Button from "../../../components/Button";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Debe tener al menos 2 caracteres")
    .max(50, "Debe tener menos de 50 caracteres")
    .required("Requerido")
});

const Configuration = ({ t, team, handleUpdateTeam, loading }) => (
  <Page>
    <Content>
      <h1 style={{ marginBottom: 24 }}>{t("global:configuration")}</h1>
      <FormConfig
        validationSchema={validationSchema}
        initialValues={parseTeamUsers(team)}
        onSubmit={handleUpdateTeam}
      >
        {({ isValid }) => (
          <Form>
            <DetailsForm />
            <UsersForm ownerId={team.owner} />
            <Message marginBottom={24} marginTop={24} type="primary-lighter">
              {t(`team:usersDisclaimer`)}
            </Message>
            <Button
              disabled={!isValid}
              loading={loading}
              type="primary"
              size="lg"
              htmlType="submit"
            >
              {t("global:save")}
            </Button>
          </Form>
        )}
      </FormConfig>
    </Content>
  </Page>
);

export default compose(
  withTranslation(["team", "global"]),
  connect(
    R.applySpec({
      users: R.pathOr([], ["company", "users"])
    }),
    { updateTeam }
  ),
  isLoading(UPDATE_TEAM),
  withHandlers({
    handleUpdateTeam: ({ users, updateTeam }) => team =>
      updateTeam(formatTeamUsers(users, team))
  })
)(Configuration);
